import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconPageTextAdd: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"page-text-add"} maskId="square-filled-radius-0-stroke-1-IconPageTextAdd"><path fillRule="evenodd" clipRule="evenodd" d="M4 22V2H20V14H17V17H14V20H17V22H4ZM8 6H16V7H8V6ZM8 10H12V11H8V10Z" fill="currentColor"/><path d="M19 18V15H18V18H15V19H18V22H19V19H22V18H19Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconPageTextAdd;
